export default "__VITE_ASSET__d2eaa140__"